import { AssignmentType, PhaseType } from 'models/enum';
import { CaseStudy, CaseStudyPhase, NewAssignment, SimulationEhr } from 'models/ui';
import { assetHelper } from 'helpers';
import { Avatar, Box, ChartsInvolved } from 'components/common';
import { ELSTab, ELSTabGroup } from 'components/common/els';
import OverviewTab, { OverviewTabProps } from './OverviewTab';
import Phases from './Phases';
import { Tabs } from './QuickView';
import { instructorSelectors } from 'redux/ducks/instructor';
import { connect } from 'react-redux';

export interface AssignmentInfoViewProps {
  activeTab: number;
  selectedContent: CaseStudy | SimulationEhr;
  onTabGroupClick: Function;
  isBookOrganized: boolean;
  newAssignment?: NewAssignment;
  assignmentType?: AssignmentType;
}

const AssignmentInfoView = (props: AssignmentInfoViewProps) => {
  const { id, patient, diagnosis, sherpathModule, totalTimeLimit, concept, learningObjective, phases } = props.selectedContent || {};
  const isSimulationAssignment = props.newAssignment?.assignmentType ? props.newAssignment?.assignmentType === AssignmentType.SIMULATION : props.assignmentType === AssignmentType.SIMULATION;
  if (!id) {
    return null;
  }
  const filteredPhases = phases?.length ? (phases as CaseStudyPhase[]).filter((phase) => phase.type !== PhaseType.OVERVIEW) : [];
  const overviewViewProps: OverviewTabProps = {
    diagnosis,
    chapter: sherpathModule,
    totalTimeLimit,
    concept,
    learningObjective,
    totalPhases: filteredPhases.length,
    isBookOrganized: props.isBookOrganized,
    assignmentType: props.newAssignment?.assignmentType
  };
  const chartsInvolved = [];

  filteredPhases.forEach((phase) => {
    if (phase.chartsInvolved?.length) {
      phase.chartsInvolved.forEach((chart) => !chartsInvolved.includes(chart) && chartsInvolved.push(chart));
    }
  });

  const avatarUrl = assetHelper.getStaticPatientAvatar(patient.avatarUrl);

  return (
    <>
      <Box mt2 className="quick-view__tab-group">
        <ELSTabGroup role="tabpanel" autoFocusTab activeIndex={props.activeTab} onChangeActiveIndex={props.onTabGroupClick}>
          <ELSTab title="Overview" />
          {!isSimulationAssignment && <ELSTab title="Charts involved" />}
          <ELSTab title="Phases" />
        </ELSTabGroup>
        {patient.avatarUrl && <Avatar name="AA" image={avatarUrl} className="quick-view__avatar" />}
      </Box>
      {props.activeTab === Tabs.OVERVIEW && <OverviewTab {...overviewViewProps} />}
      {props.activeTab === Tabs.CHARTS_INVOLVED && !isSimulationAssignment && <ChartsInvolved charts={chartsInvolved} />}
      {((isSimulationAssignment && props.activeTab === 1) || (!isSimulationAssignment && props.activeTab === Tabs.PHASES)) && <Phases phases={filteredPhases} />}
    </>
  );
};

const mapStateToProps = (state) => ({
  newAssignment: instructorSelectors.getNewAssignment(state)
});

AssignmentInfoView.displayName = 'TabsView';
export { AssignmentInfoView as BaseAssignmentInfoView };
export default connect(mapStateToProps)(AssignmentInfoView);
